import React, { useEffect, useState } from 'react';
import { Box, Flex, Spinner, Text } from "@chakra-ui/react"
import GButton from "components/ui/button/Button"
import { useTranslation } from 'react-i18next';
import AddBrancheKitchenFlowModal from './modal/AddBrancheKitchenFlowModal';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getKitchenFlowBranches } from '../services/kitchenFlowService';
import KitchenFlowBrancheTable from './KitchenFlowBrancheTable';

const KitchenFlowBranche = () => {

    const { t } = useTranslation();

    const [showModal,setShowModal]=useState(false)

    const id=useParams()
    const dispatch=useDispatch()

    useEffect(()=>{
      dispatch(getKitchenFlowBranches(id.id))
    },[dispatch,id])

    const branchesData = useSelector(state => state.kitchenFlow);
    //console.log(branchesData)
  return (
    <Box style={{marginTop:"15px"}}>
    <Flex
    alignItems="center" justifyContent="space-between"
    gap={2} flexWrap="wrap" mb={6}
  >
    <Text color="text" textTransform="capitalize">
      {t("pages.kitchenFlow.branches")}
    </Text>
    <GButton
      title={t("pages.kitchenFlow.add_branche")}
      bg="light"
      color="text"
      fontSize="14px"
      border="1px solid"
      borderColor="border"
      hover={{ bg: "light" }}
      onClick={() => setShowModal( true)}
    />
  </Flex>




    
  {branchesData.isLoading ? (
    <Spinner />
  ) : branchesData.kitchenFlowBranches?.length === 0 ? (
    <Flex
      p={4} bg="white" alignItems="center" justifyContent="center" color="text" textTransform="capitalize"
      boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)" borderRadius={6}
    >
      {t("pages.branches.no_data")}
    </Flex>
  ) : branchesData.kitchenFlowBranches?.length > 0 ? (
    <KitchenFlowBrancheTable
    data={branchesData.kitchenFlowBranches}
    />
  ):(
    <Flex
    p={4} bg="white" alignItems="center" justifyContent="center" color="text" textTransform="capitalize"
    boxShadow="0rem 0.3125rem 0.3125rem 0rem rgba(82, 63, 105, 0.05)" borderRadius={6}
  >
    {t("pages.branches.no_data")}
  </Flex>
  )
}

  




  

{
    showModal&&(
        <AddBrancheKitchenFlowModal onClose={() => setShowModal(false)}/>
    )

 }






    </Box>
  );
}

export default KitchenFlowBranche;
